import React from "react";
import { useNavigate } from "react-router-dom";
import { useGridMenuItem } from "ag-grid-react";
import { CustomMenuItemProps } from "ag-grid-react";

export interface InfoMenuItemProps extends CustomMenuItemProps {
  tableName?: string;
  id?: string;
  contextColumnName?: string;
  joinId?: string;
}

export default function InfoMenuItem({
  name,
  tableName,
  id,
  joinId,
  contextColumnName,
}: InfoMenuItemProps) {
  const navigate = useNavigate();

  useGridMenuItem({
    configureDefaults: () => true,
    select: () => {
      const params = new URLSearchParams(window.location.search);
      params.append("contextColumnName", contextColumnName || "");
      params.append("origineTableName", tableName || "");
      params.append("origineTableId", id || "");
      params.append("origineId", joinId || "");
      params.append("contextInfo", "true");
      navigate({ search: params.toString() });
    },
  });

  return (
    <div>
      <span className="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
      <span className="ag-menu-option-part ag-menu-option-text" role="presentation">
        {name}
      </span>
      <span className="ag-menu-option-part ag-menu-option-popup-pointer"></span>
      <span className="ag-menu-option-part ag-menu-option-popup-pointer"></span>
    </div>
  );
}
